/**
 * External Dependencies
 */
import 'jquery';
import 'parsleyjs';
import Swiper from 'swiper';
import { Autoplay, EffectFade, EffectCards, Pagination, Navigation } from 'swiper/modules';
import AOS from 'aos';
import ClipboardJS from 'clipboard';
import { CountUp } from 'countup.js';
import Cookies from 'js-cookie'
import Layzr from 'layzr.js'

$(document).ready(() => {
  const $document = $(document),
        $window = $(window),
        $body = $('body'),
        $banner = $('#banner'),
        $bannerSearchActive = $('#banner-search-active'),
        urlParams = new URLSearchParams(window.location.search),
        bannerShadowClass = 'scrolling',
        bannerScrollOffset = 24,
        breakpointLg = window.matchMedia('(min-width: 1024px)');

  function setBannerShadow() {
    if (($document.scrollTop() > bannerScrollOffset) || $bannerSearchActive.prop('checked')) {
      $banner.addClass(bannerShadowClass);
    } else {
      $banner.removeClass(bannerShadowClass);
    }
  }

  $window.on('scroll', setBannerShadow);
  setBannerShadow();

  $('.swiper').each(function() {
    const effect = $(this).hasClass('swiper-cards') ? 'cards' : 'fade',
          loop = $(this).hasClass('swiper-loop') ? true : false,
          navigation = $(this).hasClass('swiper-navigation') ? {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          } : false;

    new Swiper(this, {
      modules: [Autoplay, EffectFade, EffectCards, Pagination, Navigation],
      touchEventsTarget: 'wrapper',
      grabCursor: true,
      loop: loop,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      effect: effect,
      navigation: navigation,
      fadeEffect: {
        crossFade: true,
      },
      slidesPerView: 1,
      pagination: {
        el: '.swiper-pagination',
        clickable: 'true',
        type: 'bullets',
      },
    });
  });

  // Set aria attributes on toggle
  const $ariaToggles = $('.aria-toggle'),
        $navActive = $('#nav-active'),
        $bannerSearchInput = $('#banner-search-input');

  $ariaToggles.on('change', (e) => {
    if (e.target.id) {
      $('[for="' + e.target.id + '"]').attr('aria-expanded', e.target.checked ? 'true' : 'false');
    }
  });

  $navActive.on('change', (e) => {
    $bannerSearchActive.prop('checked', false);
  });

  $bannerSearchActive.on('change', (e) => {
    if (e.target.checked) {
      $bannerSearchInput.focus();
    } else {
      $bannerSearchInput.trigger('blur');
    }
    setBannerShadow();
  });

  // Animate-on-scroll init
  AOS.init({
    disable: () => {
      return breakpointLg.matches === false;
    },
    once: true,
  });

  $document.on('aos:in:count-up', ({ detail }) => {
    const $el = $(detail),
          $countUp = $el.find('[data-count-up][id]');
    
    if ($countUp.length) {
      const countUp = new CountUp($countUp.attr('id'), $countUp.data('count-up'));
    
      if (!countUp.error) {
        countUp.start();
      } else {
        console.error(countUp.error);
      }
    }
  });

  // Init Clipboard
  const $clipboardEls = $('[data-clipboard-text]');

  if (ClipboardJS.isSupported()) {
    const clipboards = new ClipboardJS('[data-clipboard-text]');

    clipboards.on('success', function(e) {
      alert('Link copied!');
    
      e.clearSelection();
    });

    $clipboardEls.removeClass('hidden');
  }

  // Modal functions
  let openModal = (modal) => {
    const $modal = $(modal);

    if ($modal.length) {
      const $modalBg = $modal.find('.modal-bg'),
            $modalDialog = $modal.find('.modal-dialog'),
            animateClass = 'ease-out duration-300',
            translateFromClass = 'translate-y-4 md:translate-y-0 md:scale-95',
            translateToClass = 'translate-y-0 md:scale-100';
            
      $body.addClass('overflow-hidden');
      $modal.removeClass('hidden');
      $modal.addClass('fixed');
      $modalBg.addClass('opacity-0 ' + animateClass);
      $modalDialog.addClass('opacity-0 ' + translateFromClass + ' ' + animateClass);

      setTimeout(() => {
        $modalBg.removeClass('opacity-0');
        $modalBg.addClass('opacity-100');
        $modalDialog.removeClass('opacity-0 ' + translateFromClass);
        $modalDialog.addClass('opacity-100 ' + translateToClass);

        setTimeout(() => {
          $modalBg.removeClass(animateClass);
          $modalDialog.removeClass(animateClass);
        }, 300);
      }, 5);

      return true;
    }

    return false;
  };

  let closeModal = (modal) => {
    const $modal = $(modal);

    if ($modal.length) {
      const $modalBg = $modal.find('.modal-bg'),
            $modalDialog = $modal.find('.modal-dialog'),
            animateClass = 'ease-in duration-150',
            translateFromClass = 'translate-y-0 md:scale-100',
            translateToClass = 'translate-y-4 md:translate-y-0 md:scale-95';
            
      $modalBg.addClass('opacity-100 ' + animateClass);
      $modalDialog.addClass('opacity-100 ' + translateFromClass + ' ' + animateClass);

      setTimeout(() => {
        $modalBg.removeClass('opacity-100');
        $modalBg.addClass('opacity-0');
        $modalDialog.removeClass('opacity-100 ' + translateFromClass);
        $modalDialog.addClass('opacity-0 ' + translateToClass);

        setTimeout(() => {
          $modalBg.removeClass(animateClass);
          $modalDialog.removeClass(animateClass);
          $modal.removeClass('fixed');
          $modal.addClass('hidden');
          $body.removeClass('overflow-hidden');
        }, 300);
      }, 5);

      return true;
    }

    return false;
  };

  // Age verification
  if (!Cookies.get('ageConsent')) {
    openModal('#age-verification');

    $('#age-verification-yes').click(() => {
      Cookies.set('ageConsent', 1, {
        expires: 9999,
      });
      closeModal('#age-verification');
    });

    $('#age-verification-no').click(() => {
      closeModal('#age-verification');

      setTimeout(() => {
        openModal('#age-verification-fail');
      }, 310);
    });
  }

  // Age consent form submission
  const $ageConsentForms = $('[data-age-consent]');

  $ageConsentForms.on('submit', (e) => {
    e.preventDefault();

    const form = e.target,
          monthField = $(form).find('[name="month"]'),
          dateField = $(form).find('[name="date"]'),
          yearField = $(form).find('[name="year"]');

    if (monthField && dateField && yearField) {
      const month = monthField.val(),
            date = dateField.val(),
            year = yearField.val(),
            birthDate = new Date(year, month, date),
            currentDate = new Date();

      let ageYears = currentDate.getFullYear() - birthDate.getFullYear();
      let ageMonths = currentDate.getMonth() - birthDate.getMonth();
      let ageDates = currentDate.getDate() - birthDate.getDate();

      if (ageMonths < 0 || (ageMonths == 0 && ageDates < 0)) {
        ageYears -= 1;
      }

      closeModal('#age-verification');

      if (ageYears >= 21) {
        Cookies.set('ageConsent', 1, {
          expires: 9999,
        });
      } else {
        setTimeout(() => {
          openModal('#age-verification-fail');
        }, 310);
      }
    } else {
      closeModal('#age-verification');

      setTimeout(() => {
        openModal('#age-verification-fail');
      }, 310);
    }
  });

  // Progress bar
  const $progressBarWrapper = $('<div class="absolute z-10 top-0 inset-x-0">'),
        $progressBar = $('<div class="h-1 w-0 bg-yellow-og">'),
        h = document.documentElement,
        b = document.body,
        st = 'scrollTop',
        sh = 'scrollHeight';

  $(document).scroll(() => {
    let scrolled = (h[st]||b[st]) / ((h[sh]||b[sh]) - h.clientHeight) * 100;

    $progressBar.css('width', scrolled + '%');
  });

  $banner.append($progressBarWrapper.append($progressBar));

  const layzr = Layzr();

  layzr.update()
       .check()
       .handlers(true);

  function lazyLoad() {
    const $el = $(this);

    $el.removeClass('opacity-0');
  }

  $('.lazy-load').load(lazyLoad);

  // Load more pagination
  const $loadMore = $('[data-load-more][data-container][data-page][data-per-page][data-total]');

  $loadMore.click((e) => {
    e.preventDefault();

    const $button = $(e.target),
          $container  = $($button.data('container')),
          loadMoreUrl = $button.data('load-more'),
          brand = $button.data('brand'),
          category = $button.data('category'),
          query = $button.data('query'),
          perPage = $button.data('per-page'),
          total = $button.data('total');

    let page = $button.data('page'),
        ajaxData = { 
          page: ++page,
        };

    if (brand) {
      ajaxData.brand = brand;
    }

    if (category) {
      ajaxData.category = category;
    }

    if (query) {
      ajaxData.query = query;
    }

    $button.attr('disabled', 'disabled');

    $.ajax(loadMoreUrl, {
      data: ajaxData,
      success: function(r) {
        const $results = $(r);

        $results.find('.lazy-load').load(lazyLoad);

        $container.append($results);

        layzr.update()
             .check();

        $button.removeAttr('disabled');

        let page = urlParams.get('page') ? urlParams.get('page') : 1;

        urlParams.set('page', ++page);

        window.history.replaceState({}, '', decodeURIComponent(`${window.location.pathname}?${urlParams}`));

        if ((page * perPage) < total) {
          $button.data('page', page);
        } else {
          $button.detach();
        }
      },
      error: function(e) {
        console.log(e);
      },
    });
  });

  // Ajax form submission
  const $ajaxForms = $('[data-wp-ajax]');

  $ajaxForms.on('submit', (e) => {
    e.preventDefault();

    const form = e.target,
          $formInput = $(form).find('[data-wp-ajax-input]'),
          $formSuccess = $(form).find('[data-wp-ajax-success]');
    
    $.ajax(form.action, {
      method: form.method,
      data: $(form).serialize(),
      success: function(r) {
        $formInput.addClass('hidden');
        $formSuccess.removeClass('hidden');
      },
      error: function() {
        alert('Something went wrong');
      },
    });
  });
});
